import type { ComponentType } from "react";
import z from "zod";
import type { WidgetValueType, WidgetValueTypes } from "view/dashboard/types/widget";

export type ConfigFormProps = {
	prefix: string;
};

export type SourceResult<T,> = {
	value: T | undefined;
	loading: boolean;
	error?: Error;
};

export type WidgetSource<Type extends WidgetValueType, Config,> = {
	valueType: Type;
	label: string;
	configSchema: z.ZodType<Config>;
	form: ComponentType<ConfigFormProps>;
	useValue: (config: Config) => SourceResult<WidgetValueTypes[Type]>;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export type RegisteredSource = { [K in WidgetValueType]: WidgetSource<K, any> }[WidgetValueType];
export type ResolvedSource = WidgetSource<WidgetValueType, any>;

export const createWidgetSource = <K extends WidgetValueType, Config,>(source: WidgetSource<K, Config>) => source;
